/* Koala <-> Hue Cart shim.
   Koala Upsell Gift has no built-in reload strategy for Hue Cart Drawer, so after any
   /cart/add.js call Koala falls through to window.location.reload() causing a page flash.
   Defining window.opusOpen makes Koala's Opus strategy "available" — Koala calls it
   instead of reloading, and we route the call to Hue's real drawer opener. */
if (typeof window !== 'undefined' && !window.opusOpen) {
  window.opusOpen = function () {
    try {
      if (window.wowcart && typeof window.wowcart.openSlideCart === 'function') {
        window.wowcart.openSlideCart();
      }
    } catch (e) { /* no-op */ }
  };
}

(function () {
  'use strict';

  var UPSELL_MAP = {
    '59228685172817': { subVariantId: '59226382270545' },
    '59228685205585': { subVariantId: '59226382303313' }
  };

  /* Subscription variants (Single + Double, Natural + Mango). Tumbler upsell
     also shows alongside these in the cart, but the sub-upgrade + scoop do NOT. */
  var SUB_VARIANT_IDS = {
    '59226382270545': true,  /* Single Sub Natural */
    '59226382303313': true,  /* Single Sub Mango */
    '59226255884369': true,  /* Double Sub Natural */
    '59226255917137': true   /* Double Sub Mango */
  };

  /* Scoop add-on: shown only when a single-tub variant is in cart.
     Adds Metal Scoop (variant 59228861923409) and applies discount code
     GRNS_MEMBER_SCOOP for $1 off → final $3.99 (product price is $4.99). */
  var SCOOP_VARIANT_ID = '59228861923409';
  var SCOOP_DISCOUNT_CODE = 'GRNS_MEMBER_SCOOP';
  var SCOOP_PRICE_DISPLAY = '$3.99';
  var SCOOP_COMPARE_DISPLAY = '$4.99';
  var SCOOP_IMAGE = 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/NutritionalLabel_7.webp?v=1774319376';

  /* Tumbler upsell: shown alongside scoop when single tub in cart. */
  var TUMBLER_VARIANT_ID = '58283630690385';
  var TUMBLER_PRICE_DISPLAY = '$39.99';
  var TUMBLER_COMPARE_DISPLAY = '$49.99';
  var TUMBLER_IMAGE = 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/Nutritional_Label_53.webp?v=1767417812';

  var STORAGE_KEY = 'grns_upsell_pending_remove';
  var debounceTimer;
  var swapping = false;
  var addingScoop = false;
  var addingTumbler = false;

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function openCartWhenReady() {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (window.wowcart && typeof window.wowcart.openSlideCart === 'function') {
        clearInterval(interval);
        window.wowcart.openSlideCart();
        // Verify it actually opened after animation; retry once if not
        setTimeout(function () {
          if (!document.body.classList.contains('wow-cart-opened') &&
              window.wowcart && typeof window.wowcart.openSlideCart === 'function') {
            window.wowcart.openSlideCart();
          }
        }, 700);
      }
      if (attempts >= 100) clearInterval(interval);
    }, 100);
  }

  // On page load: complete any pending remove from a previous interrupted swap
  function handlePendingRemove() {
    var pendingVariantId = sessionStorage.getItem(STORAGE_KEY);
    if (!pendingVariantId) return;
    sessionStorage.removeItem(STORAGE_KEY);

    document.documentElement.classList.add('grns-cart-updating');

    fetchCart().then(function (cart) {
      var lineKey = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === pendingVariantId) {
          lineKey = cart.items[i].key;
          break;
        }
      }
      var removePromise = lineKey
        ? fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          })
        : Promise.resolve();

      return removePromise;
    }).then(function () {
      document.documentElement.classList.remove('grns-cart-updating');
      setTimeout(openCartWhenReady, 600);
    }).catch(function () {
      document.documentElement.classList.remove('grns-cart-updating');
      setTimeout(openCartWhenReady, 600);
    });
  }

  function swapVariant(singleVariantId, quantity) {
    var subVariantId = UPSELL_MAP[String(singleVariantId)].subVariantId;
    sessionStorage.setItem(STORAGE_KEY, String(singleVariantId));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: subVariantId, quantity: quantity, selling_plan: 1252687953 })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          sessionStorage.removeItem(STORAGE_KEY);
          throw new Error(data.description || data.message || 'Add failed');
        }
        return fetchCart().then(function (cart) {
          var lineKey = null;
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].variant_id) === String(singleVariantId)) {
              lineKey = cart.items[i].key;
              break;
            }
          }
          if (!lineKey) { sessionStorage.removeItem(STORAGE_KEY); return; }
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          }).then(function () {
            sessionStorage.removeItem(STORAGE_KEY);
          });
        });
      });
    });
  }

  function refreshDrawer() {
    document.querySelectorAll('.grns-upsell-block').forEach(function (el) { el.remove(); });
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (data) {
      if (!data['cart-icon-bubble']) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = data['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      var newBubble = tmp.querySelector('#cart-icon-bubble');
      if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;
    }).catch(function () {});
    if (window.wowcart && typeof window.wowcart.closeSlideCart === 'function') {
      window.wowcart.closeSlideCart();
      setTimeout(openCartWhenReady, 700);
    }
  }

  function buildUpsellBlock(singleVariantId, quantity) {
    var el = document.createElement('div');
    el.className = 'grns-upsell-block grns-upsell-block--sub';
    el.innerHTML =
      '<div class="grns-upsell-block__inner">' +
        '<div class="grns-upsell-block__text">' +
          '<span class="grns-upsell-block__title">Upgrade to a subscription</span>' +
          '<span class="grns-upsell-block__sub">Save 12% + receive a free Welcome Kit</span>' +
        '</div>' +
        '<button class="grns-upsell-block__btn" type="button">Upgrade</button>' +
      '</div>';
    el.querySelector('.grns-upsell-block__btn').addEventListener('click', function () {
      if (swapping) return;
      swapping = true;
      var btn = this;
      btn.disabled = true;

      var oldWrapper = document.querySelector('.wow-cart-product-item[data-variant_id="' + singleVariantId + '"]');
      oldWrapper = oldWrapper ? (oldWrapper.closest('.wow-cart-product-item__wrapper') || oldWrapper.parentNode) : null;
      if (oldWrapper) oldWrapper.style.cssText += ';opacity:0;transition:opacity 0.25s ease;pointer-events:none;';
      el.style.cssText += ';opacity:0;transition:opacity 0.25s ease;pointer-events:none;';

      swapVariant(singleVariantId, quantity).then(function () {
        if (typeof gtag === 'function') gtag('event', 'grns_upsell_upgrade', { variant_id: String(singleVariantId) });
        refreshDrawer();
        setTimeout(function () { swapping = false; }, 2000);
      }).catch(function (err) {
        swapping = false;
        console.error('GRNS upsell swap failed:', err);
        if (oldWrapper) oldWrapper.style.cssText = oldWrapper.style.cssText.replace(/opacity:[^;]+;?/g, '').replace(/transition:[^;]+;?/g, '').replace(/pointer-events:[^;]+;?/g, '');
        el.style.cssText = el.style.cssText.replace(/opacity:[^;]+;?/g, '').replace(/transition:[^;]+;?/g, '').replace(/pointer-events:[^;]+;?/g, '');
        btn.disabled = false;
      });
    });
    return el;
  }

  function subVariantsInCart(cart) {
    var inCart = {};
    var subIds = Object.values(UPSELL_MAP).map(function (v) { return String(v.subVariantId); });
    cart.items.forEach(function (item) {
      if (subIds.indexOf(String(item.variant_id)) !== -1) inCart[String(item.variant_id)] = true;
    });
    return inCart;
  }

  function scoopInCart(cart) {
    return cart.items.some(function (item) { return String(item.variant_id) === SCOOP_VARIANT_ID; });
  }

  function tumblerInCart(cart) {
    return cart.items.some(function (item) { return String(item.variant_id) === TUMBLER_VARIANT_ID; });
  }

  function addTumbler() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: TUMBLER_VARIANT_ID, quantity: 1 })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Add tumbler failed');
        return data;
      });
    });
  }

  function buildTumblerBlock() {
    var el = document.createElement('div');
    el.className = 'grns-upsell-block grns-upsell-block--tumbler';
    el.innerHTML =
      '<div class="grns-upsell-block__inner">' +
        '<div class="grns-upsell-block__text">' +
          '<span class="grns-upsell-block__title">Add Travel Tumbler</span>' +
          '<span class="grns-upsell-block__sub">' + TUMBLER_PRICE_DISPLAY + ' <span class="grns-upsell-block__compare">' + TUMBLER_COMPARE_DISPLAY + '</span></span>' +
        '</div>' +
        '<img class="grns-upsell-block__img" src="' + TUMBLER_IMAGE + '" alt="GRNS Travel Tumbler">' +
        '<button class="grns-upsell-block__btn" type="button">Add</button>' +
      '</div>';
    el.querySelector('.grns-upsell-block__btn').addEventListener('click', function () {
      if (addingTumbler) return;
      addingTumbler = true;
      var btn = this;
      btn.disabled = true;
      btn.textContent = 'Adding';
      el.style.cssText += ';opacity:0.6;transition:opacity 0.2s ease;';

      addTumbler().then(function () {
        if (typeof gtag === 'function') gtag('event', 'grns_upsell_tumbler_added', { variant_id: TUMBLER_VARIANT_ID });
        refreshDrawer();
        setTimeout(function () { addingTumbler = false; }, 1500);
      }).catch(function (err) {
        addingTumbler = false;
        console.error('GRNS tumbler upsell failed:', err);
        el.style.cssText = el.style.cssText.replace(/opacity:[^;]+;?/g, '').replace(/transition:[^;]+;?/g, '');
        btn.disabled = false;
        btn.textContent = 'Add';
      });
    });
    return el;
  }

  function addScoop() {
    /* Add scoop variant, then apply the $1-off discount code via /cart/update.js */
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: SCOOP_VARIANT_ID, quantity: 1 })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Add scoop failed');
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: SCOOP_DISCOUNT_CODE })
        });
      });
    });
  }

  function buildScoopBlock() {
    var el = document.createElement('div');
    el.className = 'grns-upsell-block grns-upsell-block--scoop';
    el.innerHTML =
      '<div class="grns-upsell-block__inner">' +
        '<div class="grns-upsell-block__text">' +
          '<span class="grns-upsell-block__title">Add GRNS Steel Scoop</span>' +
          '<span class="grns-upsell-block__sub">' + SCOOP_PRICE_DISPLAY + ' <span class="grns-upsell-block__compare">' + SCOOP_COMPARE_DISPLAY + '</span></span>' +
        '</div>' +
        '<img class="grns-upsell-block__img" src="' + SCOOP_IMAGE + '" alt="GRNS Steel Scoop">' +
        '<button class="grns-upsell-block__btn" type="button">Add</button>' +
      '</div>';
    el.querySelector('.grns-upsell-block__btn').addEventListener('click', function () {
      if (addingScoop) return;
      addingScoop = true;
      var btn = this;
      btn.disabled = true;
      btn.textContent = 'Adding';
      el.style.cssText += ';opacity:0.6;transition:opacity 0.2s ease;';

      addScoop().then(function () {
        if (typeof gtag === 'function') gtag('event', 'grns_upsell_scoop_added', { variant_id: SCOOP_VARIANT_ID });
        refreshDrawer();
        setTimeout(function () { addingScoop = false; }, 1500);
      }).catch(function (err) {
        addingScoop = false;
        console.error('GRNS scoop upsell failed:', err);
        el.style.cssText = el.style.cssText.replace(/opacity:[^;]+;?/g, '').replace(/transition:[^;]+;?/g, '');
        btn.disabled = false;
        btn.textContent = 'Add';
      });
    });
    return el;
  }

  function injectDrawer(cart) {
    if (swapping) return;
    document.querySelectorAll('.grns-upsell-block').forEach(function (el) { el.remove(); });
    var subsInCart = subVariantsInCart(cart);
    var scoopAlreadyAdded = scoopInCart(cart);
    var tumblerAlreadyAdded = tumblerInCart(cart);
    var tumblerInjected = false;
    cart.items.forEach(function (item, index) {
      var vId = String(item.variant_id);
      var map = UPSELL_MAP[vId];
      var isSubVariant = !!SUB_VARIANT_IDS[vId];
      if (!map && !isSubVariant) return;
      var itemEl = document.querySelector('.wow-cart-product-item.index-' + index);
      if (!itemEl) return;
      var wrapper = itemEl.closest('.wow-cart-product-item__wrapper') || itemEl.parentNode;
      if (!wrapper) return;
      var insertAfter = wrapper;

      /* Single tub → show sub upgrade + scoop */
      if (map && !subsInCart[String(map.subVariantId)]) {
        var subBlock = buildUpsellBlock(item.variant_id, item.quantity);
        wrapper.parentNode.insertBefore(subBlock, insertAfter.nextSibling);
        insertAfter = subBlock;
      }
      if (map && !scoopAlreadyAdded) {
        var scoopBlock = buildScoopBlock();
        insertAfter.parentNode.insertBefore(scoopBlock, insertAfter.nextSibling);
        insertAfter = scoopBlock;
      }
      /* Tumbler shows for BOTH single tubs and subscription variants — but only once */
      if (!tumblerAlreadyAdded && !tumblerInjected) {
        var tumblerBlock = buildTumblerBlock();
        insertAfter.parentNode.insertBefore(tumblerBlock, insertAfter.nextSibling);
        tumblerInjected = true;
      }
    });
  }

  function injectCartPage(cart) {
    if (swapping) return;
    document.querySelectorAll('.grns-upsell-row').forEach(function (el) { el.remove(); });
    var subsInCart = subVariantsInCart(cart);
    var scoopAlreadyAdded = scoopInCart(cart);
    var tumblerAlreadyAdded = tumblerInCart(cart);
    var tumblerInjected = false;
    cart.items.forEach(function (item, index) {
      var vId = String(item.variant_id);
      var map = UPSELL_MAP[vId];
      var isSubVariant = !!SUB_VARIANT_IDS[vId];
      if (!map && !isSubVariant) return;
      var row = document.getElementById('CartItem-' + (index + 1));
      if (!row) return;
      var cols = row.querySelectorAll('td').length || 5;
      var insertAfter = row;
      function addRow(block) {
        var upsellRow = document.createElement('tr');
        upsellRow.className = 'grns-upsell-row';
        var td = document.createElement('td');
        td.setAttribute('colspan', cols);
        td.className = 'grns-upsell-row__cell';
        td.appendChild(block);
        upsellRow.appendChild(td);
        insertAfter.parentNode.insertBefore(upsellRow, insertAfter.nextSibling);
        insertAfter = upsellRow;
      }
      if (map && !subsInCart[String(map.subVariantId)]) addRow(buildUpsellBlock(item.variant_id, item.quantity));
      if (map && !scoopAlreadyAdded) addRow(buildScoopBlock());
      if (!tumblerAlreadyAdded && !tumblerInjected) {
        addRow(buildTumblerBlock());
        tumblerInjected = true;
      }
    });
  }

  /* Apply inline containment styles to the discount block. Class-based styles get stripped
     by WowCart on state changes (collapsed button ↔ expanded input slider), but inline
     styles applied via setProperty('...', '...', 'important') persist. */
  function styleDiscountBlock(el) {
    if (!el) return;
    el.classList.add('grns-cart-discount-relocated');
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('position', 'relative', 'important');
    el.style.setProperty('width', 'auto', 'important');
    el.style.setProperty('max-width', 'none', 'important');
    el.style.setProperty('margin', '10px 20px', 'important');
    el.style.setProperty('padding', '0', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
    /* Constrain children */
    el.querySelectorAll('*').forEach(function (c) {
      if (c.tagName === 'INPUT' || c.tagName === 'BUTTON') {
        c.style.setProperty('max-width', '100%', 'important');
        c.style.setProperty('min-width', '0', 'important');
      }
      c.style.setProperty('box-sizing', 'border-box', 'important');
      /* Kill any float that would bust the layout */
      if (getComputedStyle(c).float !== 'none') {
        c.style.setProperty('float', 'none', 'important');
      }
    });
  }

  /* Move the WowCart "Add discount code" section from the scroll area into the fixed footer
     above the CTA. WowCart REPLACES the outer element when toggling collapsed↔expanded, but
     preserves data-attributes. So we:
       (1) On first find: move it, mark it with data-grns-discount-moved="1", apply inline styles.
       (2) On every re-render: find the marked element, re-apply inline styles, remove duplicates. */
  function moveDiscountAboveCta() {
    var app = document.getElementById('wow-cart-drawer-app');
    if (!app) return;
    var cta = app.querySelector('.wow-cart-action-cta-buttons');
    if (!cta) return;

    /* If we've already moved one, re-apply styles and clean up duplicates */
    var moved = app.querySelector('[data-grns-discount-moved="1"]');
    if (moved) {
      /* Re-apply inline styles (class may have been stripped by WowCart re-render) */
      styleDiscountBlock(moved);
      /* Make sure it's positioned right above the CTA. WowCart may re-mount it back into
         the scroll area — put it back if so. */
      if (moved.parentNode !== cta.parentNode || moved.nextSibling !== cta) {
        try { cta.parentNode.insertBefore(moved, cta); } catch (e) {}
      }
      /* Remove any freshly-recreated duplicate discount block in the scroll area */
      var freshTexts = app.querySelectorAll('.wow-cart-discount-text, .wowcart-discount-text');
      for (var f = 0; f < freshTexts.length; f++) {
        var candidate = freshTexts[f];
        if (moved.contains(candidate)) continue;
        var w = candidate;
        var n = candidate;
        while (n && n !== app && n !== document.body) {
          var cnf = (n.className && typeof n.className === 'string') ? n.className.toLowerCase() : '';
          if (/discount|coupon|promo/.test(cnf)) w = n;
          n = n.parentElement;
        }
        if (w && w !== app && !w.contains(cta) && !moved.contains(w)) w.remove();
      }
      return;
    }

    /* First-time move: find anchor + walk up to wrapper */
    var anchor = app.querySelector('.wow-cart-discount-text, .wowcart-discount-text');
    if (!anchor) {
      var els = app.querySelectorAll('span, div');
      for (var i = 0; i < els.length; i++) {
        var t = (els[i].textContent || '').trim().toLowerCase();
        if (els[i].children.length === 0 && /^(add )?discount code$/.test(t)) { anchor = els[i]; break; }
      }
    }
    if (!anchor) return;
    var wrapper = anchor;
    var node = anchor;
    while (node && node !== app && node !== document.body) {
      var cn = (node.className && typeof node.className === 'string') ? node.className.toLowerCase() : '';
      if (/discount|coupon|promo/.test(cn)) wrapper = node;
      node = node.parentElement;
    }
    if (!wrapper || wrapper === app || wrapper.contains(cta)) return;
    wrapper.setAttribute('data-grns-discount-moved', '1');
    cta.parentNode.insertBefore(wrapper, cta);
    styleDiscountBlock(wrapper);
  }

  function injectTrust() {
    var app = document.getElementById('wow-cart-drawer-app');
    if (!app) return;
    var cta = app.querySelector('.wow-cart-action-cta-buttons');
    if (!cta) return;
    if (document.getElementById('grns-cart-trust')) return;
    var chk = '<svg class="grns-cart-trust__ic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#4a7c59"></circle><path d="M7 12.4l3.3 3.3L17 9" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    var el = document.createElement('div');
    el.id = 'grns-cart-trust';
    el.className = 'grns-cart-trust';
    el.innerHTML =
      '<div class="grns-cart-trust__rating">' +
        '<span class="grns-cart-trust__stars">\u2605\u2605\u2605\u2605\u2605</span>' +
        '<span class="grns-cart-trust__rtxt">4.8/5 | 10,000+ daily scoops</span>' +
      '</div>' +
      '<ul class="grns-cart-trust__list">' +
        '<li>' + chk + '<span>30-day money-back guarantee</span></li>' +
        '<li>' + chk + '<span>You’re in control - skip, pause, reschedule</span></li>' +
        '<li>' + chk + '<span>Fresh, subtle flavours - no nasties</span></li>' +
      '</ul>';
    cta.parentNode.insertBefore(el, cta.nextSibling);
  }

  function run() {
    fetchCart().then(function (cart) {
      injectTrust();
      moveDiscountAboveCta();
      var hasTarget = cart.items.some(function (i) {
        var vId = String(i.variant_id);
        return UPSELL_MAP[vId] || SUB_VARIANT_IDS[vId];
      });
      if (!hasTarget) {
        document.querySelectorAll('.grns-upsell-block, .grns-upsell-row').forEach(function (el) { el.remove(); });
        return;
      }
      if (document.querySelector('.wow-cart-product-item')) injectDrawer(cart);
      if (document.querySelector('.cart-items')) injectCartPage(cart);
    });
  }

  function debounceRun() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 80);
  }

  /* Hide the legacy big "Add the GRNS tumbler now and Save!" card from whichever
     app/section is rendering it. We can't find/disable it in the app dashboard,
     so just walk the DOM, find anything containing that heading or the
     "Travel Tumbler (Free Shipping)" big card text, walk up to find its container,
     and hide it. Skips our own .grns-upsell-block elements. */
  var LEGACY_TUMBLER_SIGNATURES = [
    'Add the GRNS tumbler',
    'Add the GRNS Tumbler',
    'GRNS Tumbler now and Save'
  ];

  function hideLegacyTumblerCard() {
    var all = document.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.dataset && el.dataset.grnsLegacyHidden) continue;
      if (el.children && el.children.length > 0) continue;
      var txt = (el.textContent || '').trim();
      if (!txt || txt.length > 200) continue;

      var match = false;
      for (var s = 0; s < LEGACY_TUMBLER_SIGNATURES.length; s++) {
        if (txt.indexOf(LEGACY_TUMBLER_SIGNATURES[s]) !== -1) { match = true; break; }
      }
      if (!match) continue;

      /* Walk up to find the big card container, but never hide our own compact block */
      var node = el;
      for (var d = 0; d < 12; d++) {
        var parent = node.parentElement;
        if (!parent || parent === document.body) break;
        /* Skip if we'd be hiding one of our blocks */
        if (parent.classList && parent.classList.contains('grns-upsell-block')) break;
        node = parent;
        /* If this container contains either a Travel Tumbler image OR "Add to Cart" button OR a $price + SAVE label, it's the card */
        var inner = (node.textContent || '');
        if ((/Add to Cart|Travel Tumbler|SAVE \$/.test(inner)) && inner.length < 1500) {
          break;
        }
      }
      if (node && node !== document.body && !node.classList.contains('grns-upsell-block')) {
        node.style.setProperty('display', 'none', 'important');
        if (node.dataset) node.dataset.grnsLegacyHidden = '1';
      }
    }
  }

  function initObserver() {
    var drawerApp = document.getElementById('wow-cart-drawer-app');
    if (drawerApp) new MutationObserver(debounceRun).observe(drawerApp, { childList: true, subtree: true });
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class' && document.body.classList.contains('wow-cart-opened')) debounceRun();
      });
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    /* Persistent observer to hide the legacy big tumbler card whenever it re-renders */
    new MutationObserver(hideLegacyTumblerCard).observe(document.body, { childList: true, subtree: true });
    hideLegacyTumblerCard();
  }

  function init() {
    handlePendingRemove();
    run();
    initObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', run);
})();

